/** Bound the complete JSON read, including a response body that stops arriving. */
export async function requestJson<T>(send:(signal:AbortSignal)=>Promise<Response>,signal?:AbortSignal|null,timeoutMs=12_000):Promise<T>{
 const controller=new AbortController();
 let rejectAbort:(reason:unknown)=>void=()=>{};
 const interrupted=new Promise<never>((_,reject)=>{rejectAbort=reject;});
 const abort=()=>{controller.abort();rejectAbort(new DOMException('Request cancelled','AbortError'));};
 const timer=setTimeout(()=>{controller.abort();rejectAbort(new Error('ACCOUNT_API_TIMEOUT'));},timeoutMs);
 if(signal?.aborted)abort();else signal?.addEventListener('abort',abort,{once:true});
 try{
  if(controller.signal.aborted)return await interrupted;
  return await Promise.race([interrupted,(async()=>{
   const response=await send(controller.signal);
   const data=await response.json();
   if(!response.ok||data?.error)throw new Error(data?.error||'ACCOUNT_API_UNAVAILABLE');
   return data as T;
  })()]);
 }finally{clearTimeout(timer);signal?.removeEventListener('abort',abort);}
}
